import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../constants/channels';

export function isProfileOperation({ channel, operation }) {
  switch (channel) {
    case EBAY:
    case FAIRE: {
      return operation.getIn(['value', 'retain']) === true;
    }

    case ETSY: {
      return operation.hasIn(['value', 'templateid']);
    }

    case SHOPIFY: {
      return operation.has('templateId');
    }

    default: {
      return false;
    }
  }
}
